import React, { createContext, useContext, useState, ReactNode } from 'react';
import { DeviceInfo, getDeviceInfo } from '../utils/deviceDetection';

interface FeedbackContextType {
  isFeedbackModalOpen: boolean;
  openFeedbackModal: (location: string) => void;
  closeFeedbackModal: () => void;
  currentLocation: string;
  deviceInfo: DeviceInfo;
}

const FeedbackContext = createContext<FeedbackContextType | undefined>(undefined);

export const useFeedback = () => {
  const context = useContext(FeedbackContext);
  if (context === undefined) {
    throw new Error('useFeedback must be used within a FeedbackProvider');
  }
  return context;
};

interface FeedbackProviderProps {
  children: ReactNode;
}

export const FeedbackProvider: React.FC<FeedbackProviderProps> = ({ children }) => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [currentLocation, setCurrentLocation] = useState('');
  const [deviceInfo] = useState<DeviceInfo>(getDeviceInfo());

  const openFeedbackModal = (location: string) => {
    setCurrentLocation(location);
    setIsFeedbackModalOpen(true);
  };

  const closeFeedbackModal = () => {
    setIsFeedbackModalOpen(false);
    setCurrentLocation('');
  };

  return (
    <FeedbackContext.Provider
      value={{
        isFeedbackModalOpen,
        openFeedbackModal,
        closeFeedbackModal,
        currentLocation,
        deviceInfo,
      }}
    >
      {children}
    </FeedbackContext.Provider>
  );
}; 